<template>
  <div id="header">
    <component :is="currentComp"></component>
  </div>
</template>

<script>
import Def from './Def';
import OldUnion from './OldUnion';
import NewUnion from './NewUnion2023/index.vue';
import { unionFlag } from '../../utils';
export default {
  components: {
    Def,
    OldUnion,
    NewUnion,
  },
  data() {
    return {
      currentComp: null,
    };
  },
  async created() {
    const union = unionFlag() || sessionStorage.getItem('dffl_union');

    if (window.df_sdk_common.isBfd()) {
      const flag = await this.apis.headerApi.getIsNewUnion();
      this.currentComp = flag ? NewUnion : OldUnion;
      if (flag) {
        document.getElementById('footer').style.display = 'none';
        // document.getElementById("wrapper-inner").style.paddingBottom = "50px";
      } else {
        document.getElementById('footer').style.display = 'block';
      }
    } else {
      this.currentComp = Def;
    }
  },
};
</script>

<style lang="less" scoped>
#header {
  position: relative;
  z-index: 100;
  // box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.05);
}
</style>
